<template>
    <v-container fluid fill-height pa-6 class="main-container">
        <v-layout justify-center align-center class="auth-layout">
            <v-flex text-center class="auth-layout__column">
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    class="auth-form"
                    @submit.prevent
                >
                    <div class="title"> Авторизация </div>
                    <v-text-field
                        v-model="email"
                        placeholder="Электронная почта"
                        class="grey-input"
                        :rules="rules"
                        :error="error"
                        :error-messages="errorMessage"
                        @input="deleteError"
                    ></v-text-field>
                    <v-text-field
                        v-model="password"
                        :rules="rules"
                        :type="showPassword ? 'text' : 'password'"
                        placeholder="Пароль"
                        class="grey-input ma-0"
                        hide-details
                        dense
                        @input="deleteError"
                    >
                        <template v-slot:append>
                            <img
                                width="20"
                                height="20"
                                :src="require('@/assets/icons/eye_icon.svg')"
                                @click="showPassword = !showPassword"
                                v-if="showPassword"
                            >
                            <img
                                width="20"
                                height="20"
                                :src="require('@/assets/icons/eye_closed_icon.svg')"
                                @click="showPassword = !showPassword"
                                v-else
                            >
                        </template>
                    </v-text-field>
                    <div class="auth-link-container">
                        <a href="#" class="auth-link" @click.prevent="openReset">
                            Забыли пароль?
                        </a>
                    </div>
                    <v-btn
                        :disabled="!valid"
                        class="auth-btn"
                        type="submit"
                        @click="validate"
                    >
                        Войти
                    </v-btn>
                </v-form>
            </v-flex>
            <v-flex text-center class="auth-layout__column">
                <v-img
                    :src="require('@/assets/images/login.svg')"
                    class="d-inline-flex"
                ></v-img>
            </v-flex>
            <div class="auth-layout__title title"> Авторизация </div>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'LoginPage',
    data() {
        return {
            email: null,
            password: null,
            valid: true,
            showPassword: false,
            error: null,
            errorMessage: null,
            rules: [value => !!value || 'Обязательное поле'],
        };
    },
    methods: {
        getAccessToken() {
            this.$http.post('/users/hotel-admin/login/', {
                email: this.email,
                password: this.password,
            })
                .then((response) => {
                    localStorage.RobohotelAdminAccessToken = response.data.access_token;
                    localStorage.RobohotelAdminUserAccommodateGuests = response.data.user ? response.data.user.can_accommodate_guests : false;
                    localStorage.RobohotelAdminUserEditStructureHotels = response.data.user ? response.data.user.can_edit_structure_hotels : false;
                    this.$router.push( '/');
                    this.$router.go( 0);
                })
                .catch((error) => {
                    console.log(error);
                    this.errorMessage = "Неверный логин и (или) пароль";
                    this.error = true;
                });
        },
        validate() {
            this.valid = this.$refs.form.validate();
            if (this.valid) {
                this.getAccessToken();
            } else {
                this.errorMessage = "Обязательное поле";
            }
        },
        deleteError() {
            this.errorMessage = null;
            this.error = false;
        },
        openReset() {
            this.$router.push({ name: "resetpassword" });
        }
    }
}
</script>

<style lang="scss" scoped>
.auth-link {
    text-decoration: none;
}
</style>